import { z } from "zod";
const attributeBool = z.preprocess((arg) => {
  if (typeof arg === "string") {
    if (arg === "false" || arg === "off") return false;
    return true;
  }
  return arg;
}, z.boolean());
const attributesCodeBlockSchema = z.object({
  lang: z.string(),
  title: z.string().optional(),
  maxHeight: z.string().optional(),
  minHeight: z.string().optional(),
  lineNumbers: attributeBool.optional(),
  lineNumberStart: z.coerce.number().optional(),
  highlight: z.string().optional(),
  focus: z.string().optional(),
  added: z.string().optional(),
  removed: z.string().optional(),
  fullHeight: attributeBool.optional(),
  id: z.string().optional()
});
export {
  attributesCodeBlockSchema
};
//# sourceMappingURL=attributes.js.map
